var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageDecorCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 185 69",
    style: {
      enableBackground: "new 0 0 185 69"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;} ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185,69H0V0l25.5,40.1L185,69z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageDecorCorner);
export default __webpack_public_path__ + "static/media/image-decor-corner.61f4e05a6cabdfb40a368ad2d13782d4.svg";
export { ForwardRef as ReactComponent };